/** LiveKit identity is the stable seat ticket, not the current socket.id. */
export function livekitIdentityIsStale(
  livekitIdentity: string | undefined,
  myPlayerId: string | null | undefined,
): boolean {
  return Boolean(myPlayerId && livekitIdentity && livekitIdentity !== myPlayerId);
}
